// Module-level flag for whether the app has mounted once on the client. It
// persists across client-side navigations, so a page can seed its `mounted`
// state from it: the loading skeleton then shows only on a genuine cold load
// (or while auth is still loading), never as a one-frame flash on every route
// change. Each page still flips its own state in an effect on the first mount.
// Seeded true on prerendered pages: scripts/prerender.ts stamps
// `data-prerendered="true"` on <html> before snapshotting, so a real user loading the
// static HTML shows the captured content immediately instead of flashing back to the
// cold-load skeleton. The SPA shell (app routes, no marker) starts false as before.
let mountedOnce =
  typeof document !== 'undefined' &&
  document.documentElement.dataset.prerendered === 'true';

export const appHasMounted = (): boolean => mountedOnce;

export const markAppMounted = (): void => {
  mountedOnce = true;
};
